import { container } from "frontend-core";
import { AgentService } from "@/services/implementations/AgentService";
import { StoreService } from "@/services/implementations/StoreService";
import { StatisticService } from "@/services/implementations/StatisticService";
import { UserService } from "@/services/implementations/UserService";
import { UserRoleService } from "@/services/implementations/UserRoleService";
import { AppService } from "@/services/implementations/AppService";
import { IAppService } from "@/services/IAppService";
import { IStoreService } from "@/services/IStoreService";
import { IUserRoleService } from "@/services/IUserRoleService";
import { IUserService, USER_SERVICE_PROVIDER } from "@/services/IUserService";
import { IAgentService } from "@/services/IAgentService";
import { ISegmentationRightsService } from "@/modules/Segmentation/services/ISegmentationRightsService";
import { SegmentationRightsService } from "@/modules/Segmentation/services/implementations/SegmentationRightsService";
import { IStatisticService } from "@/services/IStatisticService";
import { ISegmentationTargetService } from "@/modules/Segmentation/services/ISegmentationTargetService";
import { SegmentationTargetService } from "@/modules/Segmentation/services/implementations/SegmentationTargetService";
import { IReportService } from "@/services/IReportService";
import { ReportService } from "@/services/implementations/ReportService";
import { ITabletAuthService } from "@/services/ITabletAuthService";
import { TabletAuthService } from "@/services/implementations/TabletAuthService";

container
  .registerSingleton<IAppService>("IAppService", AppService)
  .registerSingleton<IStoreService>("IStoreService", StoreService)
  .registerSingleton<IUserRoleService>("IUserRoleService", UserRoleService)
  .registerSingleton<IStatisticService>("IStatisticService", StatisticService)
  .registerSingleton<IUserService>(USER_SERVICE_PROVIDER, UserService)
  .registerSingleton<IAgentService>("IAgentService", AgentService)
  .registerSingleton<IReportService>("IReportService", ReportService)
  .registerSingleton<ISegmentationRightsService>(
    "ISegmentationRightsService",
    SegmentationRightsService,
  )
  .registerSingleton<ISegmentationTargetService>(
    "ISegmentationTargetService",
    SegmentationTargetService,
  )
  .registerSingleton<ITabletAuthService>("ITabletAuthService", TabletAuthService);

export { container };
